{
  "common": {
    "LoginPage.login-header": "Prijava",
    "LoginPage.login-btn": "Prijava",
    "login": "Prijava",
    "LoginPage.login.required": "Prijava je obavezna",
    "LoginPage.password": "Lozinka",
    "LoginPage.password.required": "Lozinka je obavezna",
    "LoginPage.rememberMe": "Zapamti me",
    "LoginPage.loginFailed": "Pogrešna prijava ili lozinka",
    "LoginPage.restorePassword": "Zaboravljena lozinka",
    "LoginPage.acceptRegulation": "Prijavom na platformu pristajete poštivati uvjete i pravila korištenja usluge",
    "ActivatePage.header": "Aktivacija računa",
    "ActivatePage.password": "Lozinka",
    "ActivatePage.confirmPassword": "Potvrdi lozinku",
    "ActivatePage.button": "Aktiviraj",
    "ActivatePage.activationFailed": "Aktivacija računa nije uspjela",
    "ActivatePage.passwordRequired": "Lozinka je obavezna.",
    "ActivatePage.confirmPasswordRequired": "Potvrda lozinke je obavezna.",
    "ActivatePage.confirmPasswordMatch": "Potvrda lozinke se ne podudara.",
    "ActivatePage.passwordRequirements": "Lozinka mora sadržavati najmanje 8 znakova i uključivati barem jedno veliko slovo (A-Z), jedno malo slovo (a-z), jedan broj (0-9) i jedan poseban znak (!@#$%^&*).",
    "ResetPasswordPage.header": "Promjena lozinke",
    "ResetPasswordPage.password": "Lozinka",
    "ResetPasswordPage.confirmPassword": "Potvrdi lozinku",
    "ResetPasswordPage.button": "Promijeni lozinku",
    "resetPassword": "Resetiraj lozinku",
    "resetPasswordSuccessful": "Lozinka uspješno resetirana",
    "ResetPasswordPage.resetPasswordFailed": "Promjena lozinke nije uspjela",
    "RestorePasswordPage.header": "Obnova lozinke",
    "RestorePasswordPage.button": "Obnovi lozinku",
    "RestorePasswordPage.restorePasswordFailed": "Obnova lozinke nije uspjela",
    "RestorePassword.backToLogin": "Natrag na prijavu",
    "OrganizationUsers.addAccount": "Novi račun",
    "add": "Dodaj",
    "name": "Naziv",
    "town": "Grad",
    "OrganizationUsers.addAccount.name.required": "Unesite ime korisnika",
    "OrganizationUsers.addAccount.login.required": "Unesite korisničku prijavu",
    "OrganizationUsers.addAccount.email.required": "Unesite e-mail korisnika",
    "OrganizationUsers.addAccount.email.format": "Unesite valjani e-mail",
    "OrganizationUsers.deleteAccount": "Izbriši račun",
    "OrganizationUsers.editAccount.dialogTitle": "Uredi račun",
    "OrganizationUsers.addAccount.dialogTitle": "Kreiraj novog korisnika",
    "OrganizationUsers.managesUsers": "Upravlja korisnicima",
    "OrganizationUsers.assignsProjectNumber": "Dodjeljuje broj projekta",
    "OrganizationUsers.viewsUnassignedProjects": "Pregledava nedodijeljene projekte",
    "all": "Sve",
    "ALL": "Sve",
    "company": "Tvrtka",
    "Companies.clients": "Klijenti",
    "Companies.subcontractors": "Podizvođači",
    "active": "Aktivno",
    "inactive": "Neaktivno",
    "Companies.addNew": "Dodaj novo",
    "Companies.AddCompany.header": "Dodaj novu tvrtku",
    "Companies.CompanyView.companyClientInfo": "Podaci klijenta",
    "Companies.CompanyView.companySubcontractorInfo": "Podaci podizvođača",
    "Maps.clients": "Karta klijenata",
    "Maps.clients.clientsAndBranches": "Klijenti i podružnice",
    "Maps.clients.headquarters": "Sjedišta klijenata",
    "Maps.subcontractors": "Karta podizvođača",
    "Maps.subcontractors.collectingAndTransportingSubjects": "Subjekti koji preuzimaju i transportiraju",
    "Maps.subcontractors.collectingSubjects": "Subjekti koji preuzimaju",
    "Maps.subcontractors.transportingSubjects": "Subjekti koji transportiraju",
    "branch": "Podružnica",
    "companyBranch": "Podružnica tvrtke",
    "branchName": "Naziv podružnice",
    "branchName.break": "Naziv</br>podružnice",
    "branches": "Podružnice",
    "Companies.CompanyView.infrastructure": "Infrastruktura",
    "file": "Datoteka",
    "files": "Datoteke",
    "otherFiles": "Ostale datoteke",
    "Companies.CompanyView.CompanyInfo.companyDataHeader": "Podaci o tvrtki",
    "Companies.CompanyView.CompanyInfo.correspondenceDataHeader": "Podaci za korespondenciju",
    "addNewBranch": "Kreiraj novu podružnicu",
    "Companies.CompanyView.CompanyBranches.header": "Podružnice tvrtke",
    "Companies.CompanyView.CompanyBranches.ViewCompanyBranch.AddCompanyBranch.header": "Nova podružnica",
    "Companies.CompanyView.CompanyBranches.ViewCompanyBranch.CompanyBranchData.registrationAddress.header": "Adresa registracije",
    "Companies.CompanyView.CompanyFiles.commercial.viewFile": "Prikaži dokument",
    "viewFile": "Prikaži datoteku",
    "showFiles": "Prikaži datoteke",
    "uploadFile": "Učitaj datoteku",
    "fileName": "Naziv datoteke",
    "dragAndDropAFile": "Povuci i ispusti datoteku",
    "Projects.header": "Popis projekata",
    "Projects.addNew": "Dodaj projekt",
    "Projects.AddProject.header": "Dodaj novi projekt",
    "Projects.AddProjectInfrastructure.header": "Dodaj infrastrukturu u projekt",
    "Projects.ViewProject.projectsTab": "Projekt",
    "client": "Klijent",
    "clients": "Klijenti",
    "subcontractors": "Podizvođači",
    "Projects.ViewProject.dictionaryTab": "Šifrarnici/Postavke",
    "Projects.ViewProject.Dictionary.Waste.waste": "Odaberi otpad",
    "Projects.ViewProject.termsTab": "Uvjeti",
    "Projects.ViewProject.pricesTab": "Postavi cijene",
    "Projects.ViewProject.pricesTab.button": "Promijeni cijene usluga",
    "priceChangeDate": "Datum promjene cijene",
    "changePrices": "Promijeni cijene",
    "changePrice": "Promijeni cijenu",
    "selectSubcontractor": "Odaberi podizvođača",
    "selectServiceType": "Odaberi vrstu usluge",
    "selectWasteCode": "Odaberi kod otpada",
    "service": "Usluga",
    "serviceType": "Vrsta usluge",
    "serviceType.SCHEDULED": "Planirano",
    "SCHEDULED": "Planirano",
    "serviceType.PER_REQUEST": "Po zahtjevu",
    "PER_REQUEST": "Po zahtjevu",
    "serviceType.ADDITIONAL": "Dodatno",
    "ADDITIONAL": "Dodatno",
    "serviceType.COMMUNE": "Općina",
    "COMMUNE": "Općina",
    "selectInfrastructureResource": "Odaberi infrastrukturni resurs",
    "selectHeadquarters": "Odaberi sjedište",
    "oldPrice": "Stara cijena",
    "oldPriceReceival": "Stara cijena preuzimanja klijenta",
    "newPriceReceival": "Nova cijena preuzimanja klijenta",
    "oldPriceTransport": "Stara cijena transporta klijenta",
    "newPriceTransport": "Nova cijena transporta klijenta",
    "revenueOrIS": "Opis troška",
    "isRevenue": "IZ prihod",
    "isCost": "IZ trošak",
    "revenue": "Prihod",
    "cost": "Trošak",
    "pricePerUnit": "Cijena po jedinici",
    "declaredSum": "Deklarirana suma jedinica",
    "declared": "Deklarirano",
    "declare": "Deklariraj",
    "declaredPrice": "Cijena koja proizlazi iz deklaracije",
    "declaredTransports": "Broj preuzimanja mjesečno iz deklaracije",
    "monthsCount": "Broj mjeseci za plaćanje",
    "totalPrice": "Ukupna cijena",
    "infrastructure": "Infrastruktura",
    "Projects.ViewProject.Dictionary.wasteTab": "Otpad",
    "Projects.ViewProject.Terms.General.settings": "POSTAVKE UGOVORA",
    "organization": "Interzero",
    "organizationServices": "INTERZERO USLUGE",
    "Projects.ViewProject.Terms.General.interserohSide": "Interzero je strana ugovora",
    "Projects.ViewProject.Terms.General.mass": "Dozvoljena neusklađenost mase",
    "Projects.ViewProject.Terms.General.rsi": "RSI",
    "Projects.ViewProject.Terms.General.counselling": "Savjetovanje",
    "Projects.ViewProject.Terms.General.packing": "Pakiranje",
    "Projects.ViewProject.Terms.General.poi": "WMP",
    "Projects.ViewProject.Terms.General.machineService": "Servis strojeva",
    "Projects.ViewProject.Terms.General.employeeOutsourcing": "Outsourcing zaposlenika",
    "Projects.ViewProject.Terms.Settings.mainSettings": "Glavne postavke projekta",
    "Projects.ViewProject.Terms.Settings.declaration": "Prihvaćanje promjena deklaracije",
    "Projects.ViewProject.Terms.Settings.newServices": "Nove usluge ne zahtijevaju odobrenje administratora klijenta",
    "Projects.ViewProject.Terms.Settings.branchReports": "Podružnica može generirati financijska izvješća",
    "Projects.ViewProject.Terms.Settings.clientAdminReports": "Administrator klijenta vidi preuzimanja",
    "Projects.ViewProject.Terms.Settings.assetsRequest": "Zahtjev za primitak imovine",
    "Projects.ViewProject.Terms.Settings.ISAdmin": "IZ Administrator",
    "Projects.ViewProject.Terms.Settings.clientAdmin": "Administrator klijenta",
    "Projects.ViewProject.Terms.Settings.clientBranch": "Podružnica klijenta",
    "regionalAdmin": "Regionalni administrator",
    "Projects.ViewProject.Terms.Settings.headquarters": "Naziv sjedišta",
    "Projects.ViewProject.Terms.Settings.dpr": "DPR zahtjev",
    "Projects.ViewProject.Terms.Settings.declarationISAdmin": "Prihvat promjena deklaracije: IZ Administrator",
    "Projects.ViewProject.Terms.Settings.declarationClientAdmin": "Prihvat promjena deklaracije: Administrator klijenta",
    "Projects.ViewProject.Terms.Settings.declarationClientBranch": "Prihvat promjena deklaracije: Podružnica klijenta",
    "Projects.ViewProject.Terms.Settings.declarationRegionalAdmin": "Prihvat promjena deklaracije: Regionalni administrator",
    "Projects.ViewProject.Terms.Pix.averageEUR": "Prosječna vrijednost EUR-a u mjesecu koji prethodi izvršenju usluge",
    "Projects.ViewProject.Terms.Pix.addValue": "Dodaj novu vrijednost koja se oduzima od PIX-a",
    "month": "Mjesec",
    "twoMonths": "2 Mjeseca",
    "threeMonths": "3 Mjeseca",
    "sixMonths": "6 Mjeseci",
    "Projects.ViewProject.Terms.Pix.pixRate": "Vrijednost PIX stope",
    "Projects.ViewProject.Terms.Pix.subtractedValue": "Vrijednost oduzeta od PIX-a",
    "validFrom": "Vrijedi od",
    "validUntil": "Vrijedi do",
    "Projects.ViewProject.Terms.Pix.eurPayoff": "Tečaj EUR-a",
    "Projects.ViewProject.Terms.Pix.pixPayoff": "Isplata PIX stope",
    "vatin": "OIB",
    "Projects.ViewProject.Client.HeadquartersBranches": "Sjedišta i podružnice",
    "addAllBranches": "Dodaj sve podružnice",
    "addCentral": "Dodaj centralu kao podružnicu",
    "addCompany": "Dodaj tvrtku",
    "addBranch": "Dodaj podružnicu tvrtke",
    "exportToExcel": "Izvoz u Excel",
    "Projects.ViewProject.Client.HeadquartersBranches.headquartersName": "Naziv sjedišta",
    "Projects.ViewProject.Client.HeadquartersBranches.branchesAmount": "Broj podružnica",
    "postcode": "Poštanski broj",
    "locality": "Mjesto",
    "street": "Ulica",
    "creationDate": "Datum kreiranja",
    "Projects.ViewProject.Client.HeadquartersBranches.agreement": "Ugovor",
    "Projects.ViewProject.Client.HeadquartersBranches.mpd": "MPD ",
    "Projects.ViewProject.Client.Agreements.ClientAgreements": "Ugovori klijenta",
    "Projects.ViewProject.Client.Agreements.shared": "Dijeljeno",
    "Projects.ViewProject.Client.Agreements.validFrom": "Vrijedi od",
    "forUnlimitedPeriod": "Na neograničeno vrijeme",
    "Projects.ViewProject.Client.Agreements.validUntil": "Vrijedi do",
    "noticePeriod": "Otkazni rok",
    "comment": "Komentar",
    "options": "Opcije",
    "additionalDescription": "Dodatni opis",
    "added": "Dodano",
    "addedBy": "Dodao",
    "introducedBy": "Uveo",
    "subcontractorsName": "Naziv podizvođača",
    "contact": "Kontakt",
    "firstName": "Ime",
    "lastName": "Prezime",
    "phone": "Telefon",
    "phoneNumber": "Telefonski broj",
    "email": "E-mail",
    "orderEmails": "E-mailovi za narudžbe",
    "mainContactPerson": "Glavna kontakt osoba",
    "otherContactPersons": "Druge kontakt osobe",
    "contactPersons": "Kontakt osobe",
    "contactPersonsInterzero": "Interzero skrbnik",
    "userAccounts": "Korisnički računi",
    "user": "Korisnik",
    "users": "Korisnici",
    "Projects.ViewProject.Client.UserAccounts.addUser": "Dodaj korisnika",
    "admin": "Administrator",
    "Projects.ViewProject.Client.UserAccounts.addAdmin": "Dodaj administratora",
    "regionalAdmins": "Regionalni administratori",
    "Projects.ViewProject.Client.UserAccounts.addRegionalAdmin": "Dodaj regionalnog administratora",
    "lastLogin": "Datum zadnje prijave",
    "schedule": "Raspored",
    "scheduleType": "Vrsta rasporeda",
    "scheduleType.STATIC": "Statički",
    "scheduleType.DYNAMIC": "Dinamički",
    "onDemand": "Na zahtjev",
    "report": "Izvješće",
    "reports": "Izvješća",
    "commune": "Općina",
    "communes": "Općine",
    "district": "Okrug",
    "additional": "Dodatno",
    "globalReports": "Globalna izvješća",
    "assignedBranches": "Dodijeljene podružnice",
    "Projects.ViewProject.infrastructureServices": "Infrastrukturne usluge",
    "Projects.ViewProject.services": "Usluge",
    "projectNumber": "Broj projekta",
    "Projects.ViewProject.copy": "Kopiraj",
    "Projects.ViewProject.acceptance": "Prihvaćanje",
    "Projects.ViewProject.acceptedNotActive": "DATUM POČETKA AKTIVNOSTI",
    "Projects.ViewProject.acceptedNotActiveTooltip": "Usluga čeka na svoj početni dan",
    "accept": "Prihvati",
    "sendToAcceptance": "Pošalji na odobrenje",
    "removeAcceptance": "Ukloni prihvaćanje",
    "editedBy": "Uredio",
    "Projects.ViewProject.add": "Dodaj",
    "createdBy": "Kreirao",
    "lastModified": "Zadnja izmjena",
    "lastModifiedFiles": "Zadnja izmjena datoteka",
    "variableAnnotation": "Varijabilna napomena",
    "emailForApplication": "E-mail za aplikaciju",
    "settlementUnit": "Jedinica obračuna",
    "settlementUnit.MG": "Po težini (t)",
    "settlementUnit.UNIT": "Po količini (jedinice)",
    "settlementUnit.M3": "Po količini (m3)",
    "Projects.ViewProject.clientCollectionPrice": "Preuzimanje klijenta",
    "Projects.ViewProject.subcontractorCollectionPrice": "Preuzimanje podizvođača",
    "collectionPrice": "Cijena preuzimanja",
    "Projects.ViewProject.clientTransportPrice": "Transport klijenta",
    "clientTransport": "Klijent - transport",
    "clientCollection": "Klijent - preuzimanje",
    "Projects.ViewProject.subcontractorTransportPrice": "Transport podizvođača",
    "subcontractorTransport": "Podizvođač - transport",
    "transportPrice": "Cijena transporta",
    "subcontractorCollection": "Podizvođač - preuzimanje",
    "subcontractorRoleTransporting": "Transport",
    "subcontractorRoleReceiving": "Posrednik / broker",
    "subcontractorRoleTakingOver": "Preuzimanje",
    "subcontractorRoleOther": "Ostalo",
    "subcontractorRoleReceivingCommunalWaste": "Preuzimanje komunalnog otpada",
    "paymentMethodCode": "Kod načina plaćanja",
    "paymentMethodCode.PREPAYMENT": "Predujam",
    "paymentMethodCode.TRANSFER": "Transfer",
    "separatedInvoice": "Odvojena faktura",
    "invoicingMethod": "Način fakturiranja",
    "invoicingMethod.PER_MONTH": "Po mjesecu",
    "invoicingMethod.PER_COLLECTION": "Po preuzimanju",
    "constantCost": "Konstantni trošak",
    "organizationAsSide": "IZ je strana ugovora",
    "organizationAsSideShortened": "IZ je strana",
    "reactionTime": "Vrijeme reakcije, dani",
    "reactionTimeForClient": "Vrijeme reakcije",
    "settledSubcontractorName": "Naziv podizvođača (za obračun)",
    "settledSubcontractorNameShortened": "OBRAČUNATI POD.",
    "navResource": "BC resurs",
    "navResourceNumber": "BC broj resursa",
    "servicePixRelated": "Usluga povezana s PIX-om",
    "navResourceName": "BC naziv resursa",
    "serviceDesc": "Opis usluge",
    "activationDate": "Datum aktivacije",
    "deactivationDate": "Datum deaktivacije",
    "deactivationDateAfterActivationDateRequired": "Datum deaktivacije mora biti postavljen nakon datuma aktivacije",
    "activeFromDateBeforeActivationDateRequired": "Datum početka mora biti postavljen nakon datuma aktivacije",
    "acceptanceDate": "Datum prihvaćanja",
    "Projects.ViewProject.expand": "Proširi",
    "Projects.ViewProject.collapse": "Sažmi",
    "Projects.ViewProject.serviceDeactivated": "USLUGA DEAKTIVIRANA",
    "Projects.ViewProject.serviceActivated": "USLUGA AKTIVNA",
    "Projects.ViewProject.reactivate": "REAKTIVIRAJ",
    "Projects.ViewProject.serviceForApproval": "USLUGA ZA ODOBRENJE",
    "Projects.ViewProject.serviceWaitingForApproval": "USLUGA ČEKA ODOBRENJE",
    "Projects.ViewProject.serviceRejected": "USLUGA ODBIJENA",
    "Projects.ViewProject.deactivate": "DEAKTIVIRAJ",
    "reactivate": "Reaktiviraj",
    "deactivate": "Deaktiviraj",
    "copy": "Kopiraj",
    "copyServiceToAnotherBranches": "Kopiraj u druge podružnice",
    "copyServiceToAnotherBranchesDescription": "Ovaj proces kopira uslugu na odabrane podružnice unutar projekta zajedno s cijenama, rasporedom i drugim postavkama, kao i infrastrukturnim uslugama povezanim s uslugom.",
    "copyServiceToAnotherBranchesDialogInfo": "Nakon što kliknete 'Spremi', započet će proces kopiranja. To znači da će gumb za kopiranje biti onemogućen, a krug s desne strane će postati crven. Sustav će kopirati infrastrukturu za ovu uslugu u novu uslugu ili koristiti već kopiranu infrastrukturu za sličnu uslugu. To znači da ako imamo dvije usluge s istom infrastrukturom unutar iste podružnice, sustav će stvoriti dvije kopije usluga i jednu kopiju infrastrukture. Nakon završetka procesa, gumb će ponovno biti dostupan sa zelenim krugom upozorenja.",
    "pix": "PIX",
    "monthlyPixRate": "Mjesečna PIX stopa",
    "monthlyEurPrice": "Mjesečna cijena u eurima",
    "fixedPixRate": "Fiksna PIX stopa",
    "number": "Broj",
    "sharedInfrastructureId": "ID dijeljene infrastrukture",
    "forUtilization": "Za utilizaciju",
    "settledTransportEntity": "Transportni subjekt (za obračun)",
    "settledTransportEntityShortened": "OBRAČUNATI TRANS.",
    "CARD_ACCEPTED": "Prihvaćeno",
    "CARD_PLANNED": "Planirano",
    "LINK_TO_SUBCONTRACTOR": "Poveznica na podizvođača",
    "LINK_TO_SUBCONTRACTOR_API": "Poveznica na podizvođača - API",
    "apiLinkEmail": "E-mail za povezivanje podizvođača",
    "licensePlates": "Registracijske oznake",
    "licensePlates.break": "Registracijske<br/>oznake",
    "transportEntity": "Transportni subjekt",
    "logisticMinimum": "Logistički minimum",
    "logisticMinimumSurcharge": "Nadoplata za logistički minimum",
    "countryImport": "Uvoz u AT",
    "countryExport": "Izvoz izvan AT",
    "weightReceipt": "Potvrda težine",
    "Projects.ViewProject.closestPickupTime": "Najbliže vrijeme preuzimanja:",
    "staticCalendar": "Statički kalendar",
    "dynamicCalendar": "Dinamički kalendar",
    "billingPeriodOccurrences": "Pojave u obračunskom razdoblju",
    "calendar": "Kalendar",
    "calendar.FIRST_OCCURRENCE": "Prva pojava",
    "calendar.SECOND_OCCURRENCE": "Druga pojava",
    "calendar.THIRD_OCCURRENCE": "Treća pojava",
    "calendar.FOURTH_OCCURRENCE": "Četvrta pojava",
    "calendar.FIFTH_OCCURRENCE": "Peta pojava",
    "recipientCalendar": "Kalendar primatelja",
    "frequency": "Učestalost",
    "frequency.ONE_WEEK": "Svaki tjedan",
    "frequency.TWO_WEEKS": "Svaka 2 tjedna",
    "frequency.THREE_WEEKS": "Svaka 3 tjedna",
    "frequency.FOUR_WEEKS": "Svaka 4 tjedna",
    "frequency.FIVE_WEEKS": "Svakih 5 tjedana",
    "serviceStartDate": "Datum početka usluge",
    "monday": "Pon",
    "tuesday": "Uto",
    "wednesday": "Sri",
    "thursday": "Čet",
    "friday": "Pet",
    "saturday": "Sub",
    "sunday": "Ned",
    "pixSettlementDay": "PIX-ova obračunska jedinica",
    "pixSettlementDay.MONTHLY_PREVIOUS_MONTH": "Prosječni EUR vrijednost prethodnog mjeseca",
    "pixSettlementDay.MONTHLY_CURRENT_MONTH": "Prosječni EUR vrijednost trenutnog mjeseca",
    "pixSettlementDay.DAILY_LAST_DAY_PREVIOUS_MONTH": "Posljednji dan prethodnog mjeseca",
    "pixSettlementDay.DAILY_LAST_DAY_CURRENT_MONTH": "Posljednji dan trenutnog mjeseca",
    "pixSettlementDay.DAILY_COLLECTION_DAY_PREVIOUS_DAY": "Prethodni dan",
    "pixSettlementDay.DAILY_COLLECTION_DAY_CURRENT_DAY": "Trenutni dan",
    "GlobalSettings.infrastructure.header": "Vrste infrastrukture",
    "GlobalSettings.infrastructure.tooltip.delete": "Ako se infrastruktura koristi, sustav neće dopustiti njeno uklanjanje.",
    "GlobalSettings.wastes": "Otpad",
    "GlobalSettings.wastes.tooltip.delete": "Ako se otpad koristi, sustav neće dopustiti njegovo uklanjanje.",
    "GlobalSettings.wastes.header": "Popis kodova otpada",
    "GlobalSettings.fixedAssets": "Fiksna imovina",
    "GlobalSettings.fixed-assets.header": "Interzero infrastruktura",
    "GlobalSettings.navResources": "BC resursi",
    "GlobalSettings.exchangeRates": "Tečajne stope i PIX",
    "GlobalSettings.exchangeRates.euroDaily": "Euro - dnevno",
    "GlobalSettings.exchangeRates.euroMonthly": "Euro - mjesečno",
    "Registers": "Registri",
    "Registers.projectPerson": "Osobe u projektima",
    "organizationUsers": "Korisnici organizacije",
    "Button.InfrastructureModel.add": "Dodaj novi resurs",
    "Button.InfrastructureModel.add.dialog.title": "Dodavanje nove infrastrukture",
    "Button.InfrastructureModel.edit.dialog.title": "Uređivanje infrastrukture",
    "Button.OrganizationInfrastructureModel.add": "Dodaj novi fiksni resurs",
    "Button.OrganizationInfrastructureModel.add.dialog.title": "Dodavanje novog fiksnog resursa",
    "Button.WasteModel.add": "Dodaj kod otpada",
    "Button.WasteModel.add.dialog.title": "Dodavanje koda otpada",
    "wasteName": "Naziv otpada",
    "Button.WasteModel.edit.dialog.title": "Uređivanje koda otpada",
    "Button.NavResourceModel.add": "Dodaj BC resurs",
    "Button.NavResourceModel.add.dialog.title": "Dodavanje BC resursa",
    "Button.NavResourceModel.edit.dialog.title": "Uređivanje BC resursa",
    "Button.ExchangeRateModel.add": "Dodaj vrijednost",
    "Button.ExchangeRateModel.add.dialog.title": "Dodavanje nove dnevne vrijednosti",
    "Button.ExchangeRateModel.add.pix.dialog.title": "Dodavanje nove PIX vrijednosti",
    "Button.ExchangeRateModel.add.monthly.dialog.title": "Dodavanje nove mjesečne prosječne vrijednosti",
    "Button.ExchangeRateModel.edit.dialog.title": "Uređivanje dnevne vrijednosti",
    "Button.ExchangeRateModel.edit.pix.dialog.title": "Uređivanje PIX vrijednosti",
    "Button.ExchangeRateModel.edit.monthly.dialog.title": "Uređivanje mjesečne prosječne vrijednosti",
    "Button.ProjectPerson.add": "Dodaj novu osobu",
    "Button.ProjectPerson.add.dialog.title": "Dodavanje nove osobe za projekte",
    "Button.ProjectPerson.edit.dialog.title": "Uređivanje osobe za projekte",
    "Button.ProjectInfrastructureModel.edit.dialog.title": "Uredi resurs",
    "Breadcrumb.home": "Početna",
    "Breadcrumb.companies": "Tvrtke",
    "Breadcrumb.maps": "Karte",
    "Breadcrumb.settings": "Postavke",
    "Breadcrumb.project": "Projekt",
    "Breadcrumb.projects": "Projekti",
    "Breadcrumb.registers": "Registri",
    "Breadcrumb.companies.new-company": "Nova tvrtka",
    "Breadcrumb.projects.new-project": "Novi projekt",
    "Breadcrumb.global-settings": "Postavke",
    "Breadcrumb.month-end-closing": "Zatvaranje mjeseca",
    "Breadcrumb.organization-users": "Korisnici organizacije",
    "Breadcrumb.collection-requests": "Zahtjevi za preuzimanje",
    "Breadcrumb.contact-form": "Kontakt obrazac",
    "Breadcrumb.reports": "Izvješća",
    "Breadcrumb.client-data": "Podaci o klijentu",
    "Breadcrumb.communes": "Općine",
    "Breadcrumb.commune-declarations": "Deklaracije općina",
    "Breadcrumb.pickups": "Preuzimanja",
    "Breadcrumb.today-pickups": "Današnja preuzimanja",
    "Breadcrumb.quantity-received": "Primljene količine",
    "Breadcrumb.agreements": "Ugovori",
    "Breadcrumb.decisions": "Odluke",
    "Breadcrumb.branches": "Podružnice",
    "Breadcrumb.infrastructure": "Infrastruktura",
    "Breadcrumb.archive": "Arhiva",
    "Breadcrumb.user-manual": "Priručnik",
    "Breadcrumb.documents": "Dokumenti",
    "Breadcrumb.services-to-accept": "Usluge za prihvaćanje",
    "companies": "Tvrtke",
    "maps": "Karte",
    "settings": "Postavke",
    "project": "Projekt",
    "projects": "Projekti",
    "registers": "Registri",
    "AppBar.logout": "Odjava",
    "AppBar.changeLanguage": "Promijeni jezik",
    "SmartDataTable.of": "od",
    "SmartDataTable.numberOfItems": "Redovi na stranici",
    "SmartDataTable.search": "Pretraži",
    "SmartDataTable.noData": "Nema zapisa za prikaz",
    "addFilter": "Dodaj filter",
    "yes": "Da",
    "no": "Ne",
    "Button.confirmationTitle": "Potrebna potvrda",
    "Button.confirmationCancel": "Odustani",
    "Button.confirmationMsg": "Jeste li sigurni da želite nastaviti?",
    "Button.confirmationProceed": "U redu, nastavi",
    "Common.cancel": "Odustani",
    "save": "Spremi",
    "edit": "Uredi",
    "Common.error": "Pogreška.. pokušajte ponovno kasnije",
    "Common.error.unique-error": "Pogreška dupliciranja podataka. Vrijednost već postoji u bazi podataka",
    "Common.error.validation-error": "Pogreška provjere, poslužitelj je odbio podatke obrasca.",
    "Common.delete": "Izbriši",
    "Common.back": "Natrag",
    "Common.show": "Prikaži",
    "Common.loading": "Učitavanje...",
    "Common.select": "Odaberi",
    "Common.noData": "Nema podataka",
    "Model.User.active": "Aktivan",
    "Model.User.managesUsers": "Upravlja korisnicima",
    "Model.User.assignsProjectNumber": "Dodjeljuje naziv projekta",
    "Model.User.viewsUnassignedProjects": "Pregledava nedodijeljene projekte",
    "wasteCode": "Kod otpada",
    "Model.Waste.type": "Vrsta otpada",
    "ownDescriptionOfWaste": "Vlastiti opis otpada",
    "Model.Waste.code.required": "Kod otpada je obavezan",
    "wasteDescription": "Opis otpada",
    "Model.Waste.description.required": "Opis otpada je obavezan",
    "Model.Waste.hazardous": "Opasan otpad",
    "Model.Waste.hazardousProperties": "Opasna svojstva",
    "Model.Waste.selectHazardousProperties": "Odaberi opasna svojstva",
    "Model.Waste.hazardousPropertyCode": "Kod",
    "Model.Waste.hazardousPropertyName": "Naziv",
    "Model.Waste.nonWaste": "Nije otpad",
    "Model.Infrastructure.category": "Kategorija infrastrukture",
    "Model.Infrastructure.category.required": "Kategorija infrastrukture je obavezna",
    "estimatedMassMg": "Procijenjena masa (t)",
    "estimatedMass": "Procijenjena masa",
    "Model.Infrastructure.mass.required": "Procijenjena masa je obavezna",
    "volumeM3": "Volumen",
    "volumeM3.required": "Volumen je obavezan",
    "volumeM3.matches": "Volumen mora sadržavati samo brojeve",
    "resourceName": "Resurs",
    "Model.Infrastructure.name.required": "Resurs je obavezan",
    "collectionMethod": "Stvara resurs",
    "container": "Kontejner",
    "Model.Infrastructure.InfrastructureCategory.DUMPSTER": "Kontejner za otpad",
    "Model.Infrastructure.InfrastructureCategory.ROLL_OFF_CONTAINER": "Roll-off kontejner",
    "Model.Infrastructure.InfrastructureCategory.BARREL": "Bačva",
    "Model.Infrastructure.InfrastructureCategory.BALER": "Preša za baliranje",
    "Model.Infrastructure.InfrastructureCategory.STATIONARY_PRESS": "Stacionarna preša",
    "Model.Infrastructure.InfrastructureCategory.BIG_BAG": "Velika vreća",
    "Model.Infrastructure.InfrastructureCategory.PRESS_CONTAINER": "Kontejner s prešom",
    "Model.Infrastructure.InfrastructureCategory.PALLET": "Paleta",
    "Model.Infrastructure.InfrastructureCategory.BAG": "Vreća",
    "Model.Infrastructure.InfrastructureCategory.LOOSE": "Rasuto",
    "Model.Infrastructure.InfrastructureCategory.IBC": "IBC",
    "Model.Infrastructure.InfrastructureCategory.TANK": "Spremnik",
    "Model.Infrastructure.InfrastructureCategory.BIN": "Kanta",
    "Model.Infrastructure.InfrastructureCategory.GITTERBOX": "Gitterbox",
    "Model.Infrastructure.InfrastructureCategory.PALOXE": "Paloxe",
    "Model.Infrastructure.InfrastructureCategory.ASP": "ASP",
    "Model.Infrastructure.InfrastructureCategory.ALL": "Sve",
    "Model.OrganizationInfrastructure.generatedNumber": "ID fiksne imovine",
    "Model.OrganizationInfrastructure.deprecation": "Amortizacija",
    "Model.OrganizationInfrastructure.deprecationMonths": "Period amortizacije",
    "Model.OrganizationInfrastructure.deprecationAmount": "Iznos amortizacije",
    "Model.OrganizationInfrastructure.deprecationStartDate": "Početak amortizacije",
    "Model.OrganizationInfrastructure.deprecationRate": "Stopa amortizacije (%)",
    "Model.OrganizationInfrastructure.serialNumber": "Tip / Serijski broj",
    "Model.OrganizationInfrastructure.serialNumber.required": "Tip / Serijski broj je obavezan",
    "Model.ExchangeRateModel.rate": "Vrijednost",
    "Model.ExchangeRateModel.rate.monthly": "Mjesečna vrijednost",
    "Model.ExchangeRateModel.rate.PIX": "PIX vrijednost",
    "Model.ExchangeRateModel.rate.required": "Vrijednost je obavezna",
    "Model.ExchangeRateModel.date": "Datum",
    "Model.ExchangeRateModel.date.required": "Datum je obavezan",
    "Model.NavResource.code": "Kod / Br",
    "Model.NavResource.code.required": "Kod / Br je obavezan",
    "Model.NavResource.name.required": "Naziv je obavezan",
    "type": "Tip",
    "Model.NavResource.type.required": "Tip je obavezan",
    "Model.NavResource.type.HARDWARE": "Hardver",
    "Model.NavResource.type.EMPLOYEE": "Zaposlenik",
    "unitLong": "Jedinica",
    "Model.NavResource.unit.required": "Tip jedinice je obavezan",
    "Model.NavResource.unit.MG": "Tona",
    "Model.NavResource.unit.UNIT": "Jedinica",
    "Model.NavResource.unit.SERVICE": "Usluga",
    "Model.NavResource.price": "Jedinična cijena",
    "Model.NavResource.price.required": "Jedinična cijena je obavezna",
    "Model.NavResource.accountingGroup": "Glavna računovodstvena grupa robe",
    "Model.NavResource.accountingGroup.required": "Glavna računovodstvena grupa robe je obavezna",
    "Model.NavResource.accountingGroup.CONSULTANCY": "Savjetovanje",
    "Model.NavResource.accountingGroup.COMMODITY": "Roba",
    "Model.NavResource.accountingGroup.SERVICES": "Ostale usluge",
    "Model.NavResource.accountingGroup.RSI": "RSI",
    "companyName": "Naziv tvrtke",
    "Model.Company.name.required": "Naziv tvrtke je obavezan",
    "Model.Company.vatin.required": "PDV ID je obavezan",
    "nationalCourtRegister": "MB",
    "nationalCourtRegister.matches": "MB mora sadržavati samo brojeve",
    "Model.Company.mpdNumber": "MPD broj",
    "buyerNumber": "Broj kupca",
    "creditor": "Vjerovnik",
    "debitor": "Dužnik",
    "subcontractor": "Podizvođač",
    "houseNum": "Kućni br.",
    "apartmentNum": "Broj stana",
    "province": "Županija",
    "country": "Država",
    "Model.Company.address.keeper": "Skrbnik",
    "registrationAddress": "Adresa registracije",
    "correspondenceAddress": "Adresa za korespondenciju",
    "addressInformation": "Podaci o adresi",
    "contactPerson": "Kontakt osoba",
    "notApplicable": "Nije primjenjivo",
    "paymentPeriod": "Plaćanje za razdoblje",
    "paymentPeriod.MONTH": "mjesec",
    "paymentPeriod.TWO_MONTHS": "dva mjeseca",
    "paymentPeriod.QUARTER": "kvartal",
    "paymentPeriod.YEAR": "godina",
    "paymentPeriod.NOT_APPLICABLE": "nije primjenjivo",
    "paymentDay": "Plaćanje do dana",
    "paymentDay.DAY_LAST": "zadnji dan mjeseca",
    "paymentDue": "Plaćanje u",
    "paymentDue.FIRST_MONTH": "u prvom mjesecu",
    "paymentDue.SECOND_MONTH": "u drugom mjesecu",
    "paymentDue.THIRD_MONTH": "u trećem mjesecu",
    "paymentDue.AFTER_BILLING_PERIOD": "nakon obračunskog razdoblja",
    "paymentDue.BILLING_PERIOD_LAST_MONTH": "u zadnjem mjesecu obračunskog razdoblja",
    "paymentDue.NOT_APPLICABLE": "nije primjenjivo",
    "resolutionContainerPrice": "Cijena kontejnera prema odluci",
    "resolutionPaymentPeriod": "Plaćanje za razdoblje prema odluci",
    "nextPaymentDate": "Najbliži datum plaćanja",
    "calculatedPrice": "Iznos plaćanja",
    "bankAccountNumber": "Broj računa",
    "bankPaymentReceiver": "Primatelj",
    "bankPaymentTitle": "Naslov transfera",
    "collectionDecisionNotRequired": "Odluka nije potrebna",
    "Model.Company.groupOfCompanies": "Grupa tvrtki",
    "Model.CompanyBranch.name": "Naziv podružnice",
    "Model.CompanyBranch.name.required": "Naziv podružnice je obavezan",
    "correspondenceAddressEqRegistrationAddress": "Adresa za korespondenciju je ista kao i adresa registracije",
    "Model.CompanyBranch.data": "Podaci o podružnici",
    "clientsServices": "Klijenti/Usluge",
    "quantityReceived": "Primljena količina",
    "quantityReceivedPieces": "Primljena količina (komada)",
    "volumeReceived": "Primljeni volumen",
    "agreements": "Ugovori",
    "decisionsConclusions": "Odluke/Zaključci",
    "decisions": "Odluke",
    "conclusions": "Zaključci",
    "archive": "Arhiva",
    "others": "Ostalo",
    "general": "Općenito",
    "companyShortName": "Skraćeni naziv tvrtke",
    "Model.CompanyBranch.accessionDate": "Datum pristupa",
    "Model.CompanyBranch.subcontractorType": "Tip podizvođača",
    "Model.CompanyBranch.transporting": "Transport",
    "Model.CompanyBranch.collecting": "Prikupljanje",
    "Model.CompanyBranch.capturing": "Preuzimanje",
    "Model.CompanyBranch.other": "Ostalo",
    "Model.CompanyBranch.collectorOfMunicipialWaste": "Prikupljač komunalnog otpada",
    "platformSettings": "Postavke platforme",
    "perMonth": "Po mjesecu",
    "Model.CompanyBranch.perReceipt": "Po primitku",
    "Model.ProjectClient.payoff": "Zbirni mjesečni obračun (zadano za nove usluge)",
    "Model.ProjectClient.billingSettings": "POSTAVKE NAPLATE",
    "Model.ProjectClient.paymentMethod": "Način plaćanja",
    "Model.ProjectClient.paymentConditions": "Uvjeti plaćanja",
    "Model.ProjectPerson.name": "Ime i prezime",
    "Model.ProjectPerson.name.required": "Ime i prezime je obavezno",
    "invoicingPerson": "Osoba za fakturiranje",
    "invoicingPerson.required": "Osoba za fakturiranje je obavezna",
    "projectNumberRequired": "Broj projekta je obavezan",
    "salesperson": "Prodavač",
    "salesperson.required": "Prodavač je obavezan",
    "projectNum": "Broj projekta",
    "Model.Project.data": "PODACI",
    "Model.Project.projectNumber.required": "Broj projekta je obavezan",
    "Model.Project.name.required": "Naziv projekta je obavezan",
    "projectType": "Tip projekta",
    "Model.Project.type.TRADING": "Trgovanje",
    "Model.Project.type.ONE_TIME": "Jednokratno",
    "Model.Project.type.OTHER": "Ostalo",
    "Model.Project.type.required": "Tip projekta je obavezan",
    "Model.Project.projectNameForSubcontractor": "Naziv za podizvođača",
    "Model.Project.projectNameForSubcontractor.required": "Naziv za podizvođača je obavezan",
    "Model.Project.selectMainCompany": "Odaberi glavnu tvrtku",
    "Model.Project.selectMainCompany.required": "Glavna tvrtka je obavezna",
    "Model.Project.mainCompanyName": "Glavna tvrtka",
    "projectLeadPerson": "Voditelj projekta",
    "projectLeadPerson.required": "Voditelj projekta je obavezan",
    "projectName": "Naziv projekta",
    "role": "Uloga",
    "category": "Kategorija",
    "description": "Opis",
    "mass": "Masa",
    "massMg": "Masa [t]",
    "receivedMass": "Primljena masa",
    "Model.ProjectInfrastructure.selectInfrastructure": "Odaberi infrastrukturu",
    "Model.ProjectSubcontractors.monthlyPayoff": "Mjesečna isplata",
    "Model.ProjectSubcontractors.agreements": "Ugovori podizvođača",
    "settlementPeriod": "Razdoblje obračuna",
    "settled": "Obračunato",
    "SETTLED": "Obračunato",
    "wasteServiceCode": "Kod otpada/usluge",
    "wasteNameServiceDesc": "Naziv otpada/opis usluge",
    "infrastructureContainer": "Infrastruktura(kontejner)",
    "Model.Terms.projectSettings": "Postavke projekta i sjedišta",
    "Error.CommuneUsed": "Općina i županija su korišteni od strane tvrtke",
    "Error.CommuneExists": "Općina i županija već postoje",
    "dropFileUpload": "Učitajte datoteku povlačenjem ovdje ili kliknite i dodajte jednu datoteku",
    "assignedProjects": "Dodijeljeni projekti",
    "mpdStatus": "MPD status",
    "joined": "Pridruženo",
    "owner": "Vlasnik",
    "assignProjects": "Dodijeli projekte",
    "selectProjects": "Odaberi projekte",
    "assign": "Dodijeli",
    "sharedWithBranches": "Dijeljeno s podružnicama",
    "projectNumberAndName": "Broj i naziv projekta",
    "clientName": "Naziv klijenta",
    "numberOfContainers": "Broj kontejnera",
    "containerPrice": "Cijena kontejnera",
    "priceType": "Vrsta cijene",
    "priceType.M3": "m3",
    "priceType.UNIT": "jedinica(e)",
    "priceType.MG": "t",
    "priceType.HOUR": "sat",
    "transportPriceType": "Transport (vrsta cijene)",
    "receiptSubcontractorPriceType": "Primitak (vrsta cijene podizvođača)",
    "priceReception": "Cijena prijema",
    "daysOfTheWeek": "Dani u tjednu",
    "year": "Godina",
    "modificationDate": "Datum izmjene",
    "uploadDate": "Datum učitavanja",
    "settlementType": "Tip obračuna",
    "settlementType.PER_MONTH": "Po mjesecu",
    "PER_MONTH": "Po mjesecu",
    "settlementType.PER_COLLECTION": "Po preuzimanju",
    "PER_COLLECTION": "Po preuzimanju",
    "settlementStatus": "Status obračuna",
    "reportDate": "Datum izvješća",
    "reportDateFrom": "Datum izvješća od",
    "reportDateTo": "Datum izvješća do",
    "implementationDate": "Datum implementacije",
    "implementationDateFrom": "Datum implementacije od",
    "implementationDateTo": "Datum implementacije do",
    "orderNum": "Br. narudžbe",
    "orders": "Narudžbe",
    "reportedWeight": "Prijavljena težina",
    "reportedWeightExceed": "Prijavljeno prekoračenje (težina)",
    "estimatedQuantities": "Procijenjene količine",
    "reportedQuantities": "Prijavljene količine",
    "reportedQuantitiesExceed": "Prijavljeno prekoračenje (količine)",
    "reportedExceed": "Prijavljeno prekoračenje",
    "selectFromList": "Odaberi s popisa",
    "addedDate": "Datum dodavanja",
    "status": "Status",
    "decisionsOnCollecting": "Odluke o prikupljanju",
    "otherDecisions": "Ostale odluke",
    "expirationDate": "Datum isteka",
    "transfer": "Prijenos",
    "14days": "14 dana",
    "price": "Cijena",
    "m3": "m3",
    "unit": "jedinica",
    "mg": "t",
    "currency": "Valuta",
    "byWeight": "Po težini (t)",
    "prepayment": "Predujam",
    "fixedAsset": "Fiksna imovina",
    "fixedAssetNumber": "Broj fiksne imovine",
    "is": "IZ",
    "volume": "Volumen",
    "projectInfrastructure": "Infrastruktura projekta",
    "projectInfrastructureService": "Usluga infrastrukture projekta",
    "shared": "Dijeljeno",
    "containerAmount": "Količina kontejnera",
    "lease": "Najam",
    "leasePriceClient": "Cijena najma (klijent)",
    "leasePriceSubcontractor": "Cijena najma (podizvođač)",
    "priceFrom": "Cijena od",
    "addRegionalAdmin": "Dodaj račun regionalnog administratora",
    "addAdmin": "Dodaj administratora",
    "addNewDocument": "Dodaj novi dokument",
    "commercialDocument": "Komercijalni dokument",
    "addKeeper": "Dodaj skrbnika",
    "addUserAccount": "Dodaj korisnički račun",
    "addNewCommune": "Dodaj novu općinu",
    "addLoginAccount": "Dodaj račun za prijavu",
    "addNew": "Dodaj novo",
    "addNewService": "Dodaj novu uslugu",
    "addBranchInfrastructureService": "Dodaj novu uslugu infrastrukture podružnice",
    "addNewInfrastructure": "Dodaj novu infrastrukturu",
    "importFromExcel": "Uvoz iz Excela",
    "customerKeepers": "Skrbnici kupaca",
    "subcontractorKeepers": "Skrbnici podizvođača",
    "acceptElectronicInvoices": "Prihvaćanje elektroničkih računa",
    "einvoicesSendingContacts": "Kontakti za slanje e-računa",
    "einvoices": "E-računi",
    "reportsSendingContacts": "Kontakti za slanje izvješća",
    "reportSendingContacts": "Kontakti za slanje izvješća",
    "orderContacts": "Kontakti za narudžbe",
    "download": "Preuzmi",
    "changeSubcontractorPrices": "Promijeni cijene podizvođača",
    "editContactPerson": "Uredi kontakt osobu",
    "attentionLeasePriceMessage": "Pažnja! Promijeniti ćete cijenu najma infrastrukture na kartici podružnice klijenta na projektu.",
    "monthEndClosing": "Zatvaranje mjeseca",
    "servicesSettlement": "Obračun usluga",
    "incomeInvoices": "Ulazni računi",
    "costInvoices": "Izlazni računi",
    "unsettled": "Neobračunato",
    "UNSETTLED": "Neobračunato",
    "forApproval": "Za odobrenje",
    "FOR_APPROVAL": "Za odobrenje",
    "invoiced": "Fakturirano",
    "INVOICED": "Fakturirano",
    "canceled": "Otkazano",
    "CANCELED": "Otkazano",
    "onRequest": "Na zahtjev",
    "isServices": "IZ usluge",
    "uploadWeightReceipt": "Učitaj potvrdu težine",
    "transportCompleted": "Transport završen",
    "transferSettlement": "Prebaci obračun u drugi mjesec",
    "complain": "Prigovor",
    "complaint": "Prigovor",
    "hasComplaint": "Ima prigovor",
    "cancelSettlement": "Otkaži obračun",
    "sendToNav": "Pošalji u BC",
    "settle": "Prebaci u obračunato",
    "settleMassDiscrepancyErrorInfo": "Pogreška odstupanja mase. Jeste li sigurni da želite nastaviti?",
    "discard": "Odbaci",
    "uploadNoncomplianceProtocol": "Učitaj protokol neusklađenosti",
    "column": "Stupac",
    "dateSentToNav": "Datum slanja u BC",
    "settlementCanceled": "Obračun otkazan",
    "complaintIsSettled": "Prigovor je riješen",
    "unsettledServices": "Neobračunate usluge",
    "canceledServices": "Otkazane usluge",
    "systemRemoveSettlement": "Želite li da sustav UKLONI OVAJ OBRAČUN IZ EVIDENCIJE?",
    "yesDelete": "Da, izbriši",
    "selectSettlementMonth": "Odaberite mjesec kojem želite dodijeliti obračun usluge",
    "settlementServiceCompleteData": "Za OBRAČUN USLUGE, popunite podatke",
    "settlementSuccessfullyTransfered": "Uspješno ste prebacili obračun u drugo obračunsko razdoblje",
    "january": "Siječanj",
    "february": "Veljača",
    "march": "Ožujak",
    "april": "Travanj",
    "may": "Svibanj",
    "june": "Lipanj",
    "july": "Srpanj",
    "august": "Kolovoz",
    "september": "Rujan",
    "october": "Listopad",
    "november": "Studeni",
    "december": "Prosinac",
    "shortMonth.01": "Sij",
    "shortMonth.02": "Velj",
    "shortMonth.03": "Ožu",
    "shortMonth.04": "Tra",
    "shortMonth.05": "Svi",
    "shortMonth.06": "Lip",
    "shortMonth.07": "Srp",
    "shortMonth.08": "Kol",
    "shortMonth.09": "Ruj",
    "shortMonth.10": "Lis",
    "shortMonth.11": "Stu",
    "shortMonth.12": "Pro",
    "next": "Sljedeće",
    "transportPlan": "Plan transporta",
    "companyData": "Podaci o tvrtki",
    "fillComplaintData": "Za PRIGOVOR, popunite podatke",
    "complainedMass": "Količina mase za prigovor",
    "complainedQuantities": "Količine za prigovor",
    "editActiveFields": "Možete UREDITI aktivna polja",
    "reasonForChange": "Razlog promjene",
    "croatia": "Hrvatska",
    "editData": "Uredi podatke",
    "headquarter": "Sjedište",
    "headquarterName": "Naziv sjedišta",
    "fieldRequired": "Polje je obavezno",
    "positiveNumberRequired": "Potreban je pozitivan broj",
    "notNegativeNumberRequired": "Potreban je broj koji nije negativan",
    "numberRequired": "Vrijednost mora biti broj",
    "fullName": "Puno ime",
    "accountActive": "Račun aktivan",
    "requiredValidEmail": "Potreban je valjani e-mail",
    "requiredValidEmails": "Potrebni su valjani e-mailovi, odvojeni zarezom",
    "accountActivationEmailSent": "E-mail za aktivaciju računa poslan",
    "selectBranch": "Odaberi podružnicu",
    "selectCompany": "Odaberi tvrtku",
    "placeOfWork": "Mjesto rada",
    "streetRequired": "Naziv ulice je obavezan",
    "houseNumRequired": "Kućni broj je obavezan",
    "localityRequired": "Mjesto je obavezno",
    "postcodeRequired": "Poštanski broj je obavezan",
    "postcodeInvalid": "Možete koristiti samo brojeve i crticu",
    "rights": "Prava",
    "enterValueThenPressEnter": "Unesite vrijednost, zatim pritisnite tipku \"Enter\"",
    "ballerOutputMass": "Masa bale [t]",
    "activationDate.required": "Datum aktivacije je obavezan",
    "subcontractor.required": "Podizvođač je obavezan",
    "containerAmount.required": "Količina kontejnera je obavezna",
    "leasePrice.required": "Cijena najma je obavezna",
    "reportsReport": "Prijava odvoza / status narudžbe",
    "reportPickup": "Prijavi preuzimanje",
    "reportsV2": "Status narudžbe i kontakt obrasci",
    "reportsV2.collectionRequests": "Status narudžbe",
    "declarationChanges": "Promjene deklaracije",
    "financialReports": "Financijska izvješća",
    "monthEndClosingReports": "Izvješća o zatvaranju mjeseca",
    "loginReports": "Izvješća o prijavama",
    "otherReports": "Ostalo",
    "ReportType.FINANCIAL_INCOME_AND_COSTS": "Izvješće o prihodima i troškovima",
    "ReportType.FINANCIAL_MONTHLY": "Financijsko izvješće: Mjesečno",
    "ReportType.FINANCIAL_ANNUAL": "Financijsko izvješće: Godišnje",
    "ReportType.SUBCONTRACTOR": "Izvješće o cijeni podizvođača",
    "ReportType.FINANCIAL_MONTHLY_ACHIEVEMENTS": "Financijsko izvješće: Mjesečna postignuća",
    "ReportType.MONTH_CLOSING_MISSING_INVOICES": "Zatvaranje mjeseca: Nedostajući računi",
    "OtherReportType.SUBCONTRACTOR_DECISIONS": "Odluke podizvođača",
    "OtherReportType.INFRASTRUCTURES": "Izvješće o infrastrukturi",
    "OtherReportType.NO_FORM": "NO obrazac (nastanak otpada)",
    "reportFile": "Datoteka izvješća",
    "reportPeriod": "Razdoblje izvješća",
    "financialReportPeriod.MONTHLY": "Mjesečno",
    "financialReportPeriod.CUSTOM": "Prilagođeno",
    "sumMonths": "Zbroj mjeseci",
    "contactForms": "Kontakt obrasci",
    "contactForm": "Kontakt obrazac",
    "showServices": "Prikaži usluge",
    "servicesList": "Popis usluga",
    "backToBranchesList": "Natrag na popis podružnica tvrtke",
    "pickupsInProgress": "Preuzimanja u tijeku",
    "inProgress": "U tijeku",
    "receiptSizeUnit": "Veličina primitka (jedinice)",
    "clientPrice": "Cijena klijenta",
    "subcontractorPrice": "Cijena podizvođača",
    "recipient": "Primatelj",
    "sendPickupRequest": "Pošalji ZAHTJEV ZA PREUZIMANJE",
    "tonnesOfwaste": "Masa otpada u tonama",
    "tonnesOfwaste.matches": "Masa otpada mora biti broj veći od 0.",
    "noContainersForPickup": "Broj kontejnera za preuzimanje",
    "noContainersForPickup.matches": "Broj kontejnera može sadržavati samo brojeve",
    "noContainersForPickup.exceeded": "Broj kontejnera dostupnih za ovu uslugu {{maxContainers}}",
    "branchCity": "Grad podružnice",
    "branchStreet": "Ulica podružnice",
    "concerns": "Odnosi se na",
    "collectionRequestType.PICKUP": "Zahtjev za preuzimanje",
    "collectionRequestType.SCHEDULE": "Raspored",
    "collectionRequestType.NO_PICKUP": "Bez preuzimanja",
    "collectionRequestType.EXCEED": "Prekoračenje",
    "invoiceNumber": "Broj računa",
    "open": "Otvori",
    "history": "Povijest",
    "done": "Završeno",
    "pickupDate": "Datum preuzimanja",
    "previousValue": "Prethodna vrijednost",
    "previousValueMg": "Prethodna vrijednost t",
    "previousNumberOfTransports": "Prethodni broj transporta",
    "numberOfTransports": "Broj transporta",
    "newValue": "Nova vrijednost",
    "newValueMg": "Nova vrijednost t",
    "newNumberOfTransports": "Novi broj transporta",
    "author": "Autor",
    "details": "Detalji",
    "senderLogin": "Prijava pošiljatelja",
    "senderClient": "Klijent pošiljatelj",
    "senderBranch": "Podružnica pošiljatelja",
    "sender": "Pošiljatelj",
    "dateSent": "Datum slanja",
    "message": "Poruka",
    "previousMonth": "Prethodni mjesec",
    "nextMonth": "Sljedeći mjesec",
    "reportTimeRange": "Vremenski raspon izvješća",
    "forPeriod": "Za razdoblje",
    "initialMonth": "Početni mjesec",
    "finalMonth": "Završni mjesec",
    "reportStatus": "Status izvješća",
    "decisionStatus": "Status odluke",
    "SubcontractorDecisionStatus.ALL": "Sve",
    "SubcontractorDecisionStatus.MISSED": "Propušteno",
    "SubcontractorDecisionStatus.VALID": "Valjano",
    "SubcontractorDecisionStatus.EXPIRED": "Isteklo",
    "openReports": "Otvorena izvješća",
    "closedReports": "Zatvorena izvješća",
    "reportType": "Vrsta izvješća",
    "noPickup": "Bez preuzimanja",
    "reportMissedPickup": "Prijavi propušteno preuzimanje",
    "reported": "Prijavljeno",
    "excessReported": "Prijavljen višak",
    "reportAccepted": "Izvješće prihvaćeno",
    "pickupOnHolidays": "Preuzimanje na praznike",
    "pickupRequest": "Zahtjev za preuzimanje",
    "serviceRequest": "Zahtjev za uslugu",
    "generateReport": "Generiraj izvješće",
    "requiredField": "Obavezno polje",
    "fieldToLong": "Polje predugo",
    "many": "Mnogo",
    "editProjectWaste": "Uredi otpad u projektu",
    "addPrice": "Dodaj cijenu",
    "show": "Prikaži",
    "addContact": "Dodaj kontakt",
    "sequences": "Sekvence",
    "addSequence": "Dodaj sekvencu",
    "editSequence": "Uredi sekvencu",
    "mask": "Maska",
    "mask.help": "#LP#, #ROK#, #MJESIAC#, #DZIEN# npr.: FV/#ROK#/#LP# će generirati FV/2023/1",
    "repeats": "Ponavljanja",
    "nextTry": "Sljedeći pokušaj",
    "errorMessage": "Poruka o pogrešci",
    "resourceExists": "Resurs već postoji",
    "search": "Traži",
    "seesPrices": "Vidi cijene",
    "organizationIsParticipating": "Organizacija sudjeluje u projektu",
    "clientLease": "Najam - Klijent",
    "subcontractorLease": "Najam - Podizvođač",
    "noPackage": "Nije zapakirano",
    "projectInfrastructureDescription": "Opis infrastrukture projekta",
    "infrastructureDescription": "Opis infrastrukture",
    "showAllCards": "Prikaži sve kartice",
    "showCards": "Prikaži kartice",
    "plannedTransportTime": "Planirano vrijeme transporta",
    "realTransportTime": "Vrijeme transporta",
    "initialMass": "Početna masa",
    "initialMass.break": "Početna</br>masa",
    "senderEupNumber": "Broj MPD pošiljatelja",
    "senderEupName": "Naziv MPD pošiljatelja",
    "receiver": "Primatelj",
    "receiverEupNumber": "Broj MPD primatelja",
    "receiverEupName": "Naziv MPD primatelja",
    "carrierIdentificationNumber": "Identifikacijski broj prijevoznika",
    "cardRejectionTime": "Vrijeme odbijanja kartice",
    "withdraw": "Povuci",
    "reason": "Razlog",
    "revise": "Pregledaj",
    "mutually-exclusive": "Međusobno isključivo",
    "activationDateBefore": "Datum aktivacije prije",
    "activationDateAfter": "Datum aktivacije poslije",
    "deactivationDateBefore": "Datum deaktivacije prije",
    "deactivationDateAfter": "Datum deaktivacije poslije",
    "serviceId": "ID usluge",
    "more": "Više",
    "assignBranchAccount": "Dodijeli račun podružnice",
    "remove": "Ukloni",
    "contractConclusionDate": "Datum zaključenja ugovora",
    "updateCompanyCentralBranch": "Ažuriraj centralnu podružnicu",
    "branchNestedNumber": "Br.",
    "reportForClient": "Izvješće za klijenta",
    "reportGenerated": "je generirano",
    "reportNotGeneratedMessage": "Došlo je do pogreške prilikom generiranja izvješća",
    "dateCannotBeBeforeActivationDate": "Datum ne može biti prije datuma aktivacije",
    "remarks": "Napomene",
    "receiverFirstAndLastName": "Primatelj",
    "carrierName": "Naziv prijevoznika",
    "communeDeclarations": "Deklaracije općina",
    "allProjects": "Svi projekti",
    "importLogs": "Povijest uvoza",
    "exportLogs": "Povijest izvoza",
    "uploadNewImportFile": "Učitaj novu datoteku za uvoz",
    "settlementImportStarted": "Uvoz obračuna započet",
    "settlementImportFinished": "Uvoz obračuna završen",
    "settlementImportError": "Pogreška uvoza obračuna",
    "settlementExportStarted": "Izvoz obračuna započet",
    "settlementExportFinished": "Izvoz obračuna završen",
    "settlementExportError": "Pogreška izvoza obračuna",
    "rowNumber": "Broj retka",
    "columnAddress": "Stupac",
    "filters": "Filtri",
    "exportAndImportLogs": "Povijest izvoza i uvoza",
    "exportId": "ID izvoza",
    "yearMonth": "Godina i mjesec",
    "false": "Ne",
    "true": "Da",
    "delayedEmailNotification": "Odgođena e-mail obavijest",
    "sendActivationMailToUsers": "Pošalji e-mail za aktivaciju korisnicima",
    "resendActivationMailToUser": "Ponovno pošalji e-mail za aktivaciju korisniku",
    "resendActivationMailToActiveUserError": "Aktivni korisnik ne može primiti e-mail za aktivaciju",
    "messageContent": "Sadržaj poruke",
    "dropOrSelectAttachment": "Učitajte datoteku povlačenjem ovdje ili odaberite jednu",
    "messageDetails": "Detalji poruke",
    "selectedPeriod": "Odabrano razdoblje",
    "contactFormCreated": "Kontakt obrazac kreiran",
    "containerType": "Vrsta kontejnera",
    "containerTypeDescription": "Provjerite kako kontejner izgleda:",
    "emailForNotifications": "E-mail za obavijesti",
    "emailForEInvoice": "E-mail za e-račun",
    "pickups": "Preuzimanja",
    "todayPickups": "Današnja preuzimanja",
    "showPickups": "Prikaži preuzimanja",
    "upcomingPickupsDates": "Nadolazeći datumi preuzimanja",
    "pickupFrequency": "Učestalost preuzimanja",
    "reportExceed": "Prijavi prekoračenje",
    "reportingExceed": "Prijavljivanje prekoračenja",
    "exceedAmount": "Iznos prekoračenja",
    "pickupRequestSuccess": "Zahtjev za preuzimanje uspješno poslan",
    "problemOccurrence": "Pojava problema",
    "transportingSubcontractor": "Podizvođač za transport",
    "receivingSubcontractor": "Podizvođač za primanje",
    "CARD_CONFIRMATION_GENERATED": "Potvrda generirana",
    "CARD_RECEIVE_CONFIRMATION": "Potvrda primitka",
    "CARD_TRANSPORT_CONFIRMATION": "Potvrda transporta",
    "CARD_REJECTED": "Odbijeno",
    "CARD_WITHDRAWN": "Povučeno",
    "GENERAL_ERROR": "Došlo je do pogreške",
    "INVALID_DATE": "Nevažeći datum",
    "datesMustBeInSameYear": "Datumi moraju biti u istoj godini",
    "from": "Od",
    "to": "Do",
    "user-manual": "Priručnik",
    "documents": "Dokumenti",
    "filesToDownload": "Datoteke za preuzimanje",
    "servicesToAccept": "Usluge za prihvaćanje",
    "serviceWaitingAcceptation": "Usluga čeka prihvaćanje",
    "makeAvailableToBranch": "Učini dostupnim podružnici",
    "availableToBranch": "Dostupno podružnici",
    "branchesImported.title": "Sažetak uvoza podružnica",
    "branchesImported.content": "Kreirano {{createdCount}}, ažurirano {{updatedCount}}",
    "branchesImported.errorRowsInfo": "Pogreške u redcima:",
    "branchesImportIOError": "Pogreška prilikom čitanja Excel datoteke",
    "incorrectNumberOfSheets": "Neispravan broj listova u Excel datoteci",
    "reportGenerationStarted": "Generiranje izvješća započeto",
    "receivedQuantitiesImport.started": "Uvoz primljenih količina započet",
    "receivedQuantitiesImport.success": "Uvoz primljenih količina uspješno završen",
    "receivedQuantitiesImport.error": "Pogreška prilikom uvoza primljenih količina",
    "receivedQuantitiesImport.errorWithRow": "Pogreška prilikom uvoza primljenih količina. Provjerite redak {{rowNumber}}",
    "receivedQuantitiesImport.errorWithRowColumn": "Pogreška prilikom uvoza primljenih količina. Provjerite redak {{rowNumber}}, stupac {{columnAddress}}",
    "reportGeneration.inProgress": "U tijeku",
    "reportGeneration.failed": "Pogreška",
    "reportGeneration.noData": "Nema podataka",
    "onlyPlatformMpds": "Samo MPD-ovi s platforme",
    "clientPoiInstruction": "Uputa",
    "NEW_YEAR_DAY": "Nova godina",
    "EPIPHANY": "Sveta tri kralja",
    "EASTER_MONDAY": "Uskrsni ponedjeljak",
    "LABOUR_DAY": "Praznik rada",
    "ASCENSION_DAY": "Uzašašće",
    "WHIT_MONDAY": "Duhovski ponedjeljak",
    "CORPUS_CHRISTI": "Tijelovo",
    "ASSUMPTION_DAY": "Velika Gospa",
    "NATIONAL_DAY": "Dan državnosti",
    "ALL_SAINTS_DAY": "Svi sveti",
    "IMMACULATE_CONCEPTION": "Bezgrješno začeće",
    "CHRISTMAS_DAY": "Božić",
    "ST_STEPHEN_DAY": "Sveti Stjepan",
    "onDemandPickups": "Ciklička preuzimanja",
    "onDemandPickupsDescription": "Ova tablica sadrži informacije o komunalnom otpadu, bez definiranog rasporeda preuzimanja ili s često promjenjivim rasporedom. Gumb \"prijavi višak\" koristi se za informiranje primatelja o povećanoj/iznad normalne količine otpada za preuzimanje pri sljedećem preuzimanju. Količina prijavljenih viškova zbraja se tijekom mjeseca u stupcu \"prijavljeni višak\".",
    "onDemandSettlements": "Obračuni na zahtjev",
    "exceedWillBeSummedWarning": "UPOZORENJE: Višak će se zbrojiti s prethodnim prijavama za ovu uslugu unutar ovog mjeseca",
    "addInvoiceNumberAndCommentProcessStarted": "Proces dodavanja broja računa i komentara započet",
    "upToXDays": "do {{days}}",
    "companiesList": "Popis tvrtki",
    "branchesList": "Popis podružnica",
    "resourceInBulk": "Rasuto",
    "loadingTimeClientPrice": "Vrijeme utovara klijent",
    "loadingTimeSubcontractorPrice": "Vrijeme utovara podizvođač",
    "feesClientPrice": "Naknade klijent",
    "feesSubcontractorPrice": "Naknade podizvođač",
    "fireProtectionClientPrice": "Protupožarna zaštita klijent",
    "fireProtectionSubcontractorPrice": "Protupožarna zaštita podizvođač",
    "loadingTime": "Vrijeme utovara, sati",
    "includeLoadingPrices": "Uključi cijene utovara",
    "includeFeesPrices": "Uključi cijene naknada",
    "includeFireProtectionPrices": "Uključi cijene protupožarne zaštite",
    "addNewContactForBranchLink": "Dodaj novi kontakt za podružnicu",
    "sendDelayedActivationMailWarning": "E-mail za aktivaciju bit će poslan svim neaktivnim korisnicima s uključenom 'Odgođenom e-mail obavijesti'. Nastaviti?",
    "collectionRequestDoneMessage": "Zahtjev za preuzimanje označen kao završen",
    "downloadCard": "Preuzmi prateći list za otpad",
    "nkdClass": "NKD razred",
    "transportAuthority": "Ovlast za prijevoz",
    "authority": "Ovlast",
    "reportContainersAmountForPickupWithCreatesResourceOnlyInfrastructureWarning": "Ako koristite prešu za baliranje - unesite broj bala",
    "otherPhysicalProperty": "Ostala fizička svojstva",
    "customWasteDescription": "Prilagođeni opis otpada",
    "otherWastePackaging": "Ostalo pakiranje otpada",
    "packageNumber": "Broj pakiranja",
    "wastePhysicalPropertyType": "Fizikalna svojstva otpada",
    "wastePhysicalPropertyType.DUST": "Prah",
    "wastePhysicalPropertyType.SOLID": "Krutina",
    "wastePhysicalPropertyType.PASTY": "Pastozno",
    "wastePhysicalPropertyType.SLUDGE": "Muljevito",
    "wastePhysicalPropertyType.LIQUID": "Tekuće",
    "wastePhysicalPropertyType.GASEOUS": "Plinovito",
    "wastePhysicalPropertyType.OTHER": "Ostalo",
    "wastePackagingType": "Pakiranje otpada",
    "wastePackagingType.BULK": "Rasuto",
    "wastePackagingType.VESSEL": "Posuda",
    "wastePackagingType.CONTAINER": "Kontejner",
    "wastePackagingType.BUCKET": "Kanta",
    "wastePackagingType.CANISTER": "Kanistar",
    "wastePackagingType.BARREL": "Bačva",
    "wastePackagingType.BOX": "Kutija",
    "wastePackagingType.BAG": "Vreća",
    "wastePackagingType.OTHER": "Ostalo",
    "reportOnWasteProcessing": "Izvješće o obradi otpada",
    "wasteFlowPurpose": "Namjena",
    "wasteFlowPurpose.USE": "Oporaba",
    "wasteFlowPurpose.DISPOSAL": "Zbrinjavanje",
    "wasteFlowQuantityMethod": "Metoda količine",
    "wasteFlowQuantityMethod.QUANTITY_WEIGHING": "Vaganje količine",
    "wasteFlowQuantityMethod.QUANTITY_ESTIMATE": "Procjena količine",
    "wasteFlowTransportMethod": "Način prijevoza",
    "wasteFlowTransportMethod.ROAD": "Cestovni",
    "wasteFlowTransportMethod.RAIL": "Željeznički",
    "wasteFlowTransportMethod.SEA": "Morski",
    "wasteFlowTransportMethod.AIR": "Zračni",
    "wasteFlowTransportMethod.INLAND_WATERWAYS": "Unutarnji plovnim putem",
    "senderDateOfDelivery": "Datum isporuke pošiljatelja",
    "wasteFlowLicensePlates": "Registarska oznaka",
    "carrierReceivedBy": "Prijevoznik primio",
    "carrierDeliveryDate": "Datum dostave prijevoznika",
    "carrierSubmittedBy": "Prijevoznik predao",
    "recipientReceivedBy": "Primatelj primio",
    "recipientDateOfWeighing": "Datum vaganja primatelja",
    "recipientQuantityTakenInKg": "Preuzeta količina primatelja (kg)",
    "LoginPage.generalTermsAndConditions": "Opći uvjeti poslovanja",
    "LoginPage.privacyPolicy": "Politika zaštite podataka",
    "userWithoutAssignedRole": "Korisnik bez dodijeljene role",
    "plannedFeature": "Funkcija u pripremi — ovaj ekran je najava, podaci će se pojaviti nakon njezine implementacije.",
    "featureNotImplemented": "Ova funkcija još nije implementirana.",
    "cancelOrder": "Otkaži zahtjev",
    "cancellingOrder": "Otkazivanje zahtjeva za odvoz",
    "cancellationReason": "Razlog otkazivanja",
    "cancellationReasonHint": "Razlog će biti poslan podizvođaču ako je već primio zahtjev.",
    "collectionRequestCancelledMessage": "Zahtjev za odvoz je otkazan",
    "collectionRequestDeletedMessage": "Zahtjev za odvoz je obrisan",
    "cancelledBy": "Otkazao",
    "cancelDate": "Datum otkazivanja",
    "deleteOrder": "Obriši zahtjev",
    "deleteOrderConfirmation": "Zahtjev će biti trajno obrisan i neće se pojaviti u izvještajima. Nastaviti?",
    "confirm": "Potvrdi",
    "unexpectedError": "Došlo je do neočekivane pogreške.",
    "cancel": "Odustani"
  },
  "error": {
    "E00001": "Pogreška.. pokušajte ponovno kasnije",
    "E00002": "Pogreška provjere",
    "E00003": "Nevažeći argument zahtjeva",
    "E00004": "Spremanje u bazu podataka nije uspjelo",
    "E00005": "Spremanje u bazu podataka nije uspjelo - stvorio bi se duplikat",
    "E01001": "Nije ovlašten za dodjelu broja projekta",
    "E02001": "Broj infrastrukture prekoračen",
    "E02002": "Pronađeni su zahtjevi za preuzimanje s datumom nakon datuma deaktivacije",
    "E02003": "Nevažeći datum aktivacije ili datum početka usluge",
    "E03001": "Obračuni na koje utječe promjena cijene sadrže prigovore",
    "E04001": "Tvrtka je već korištena kao podizvođač",
    "Error.ResourceUsed": "Resurs se koristi",
    "Error.ResourceActive": "Resurs nije deaktiviran",
    "Error.ProjectInfrastructureNeedsMass": "Masa infrastrukture je obavezna",
    "Error.AggregateReplayRunningException": "Portal je nedostupan zbog radova održavanja, pokušajte ponovno za nekoliko minuta",
    "Error.ResourceExists": "Resurs već postoji",
    "Error.DeactivateFailedActiveServicesExist": "Nije moguće deaktivirati, postoje aktivne usluge ili su usluge planirane",
    "Error.MissingScheduleFields": "Dani preuzimanja nisu odabrani",
    "Error.MissingRequiredRdrFile": "Nedostaje RDR datoteka podizvođača povezana s općinom klijenta",
    "Error.CannotDeleteSettlement": "Radnja bi uzrokovala uklanjanje obračunatog obračuna",
    "Error.InfrastructureServiceNotYetActive": "Priložena infrastrukturna usluga još nije aktivna",
    "Error.CannotDeactivateNotZeroSettlementsExists": "Postoje deklaracije koje nisu nula nakon datuma deaktivacije",
    "Error.InfrastructureNotExistsException": "Infrastruktura ne postoji",
    "Error.CollectionOutsideServiceActiveDate": "Datum preuzimanja izvan aktivnog razdoblja usluge",
    "Error.CollectionForDeactivatedService": "Usluga je deaktivirana",
    "Error.CannotRejectServiceWithSettlements": "Nije moguće odbiti uslugu s obračunima",
    "Error.GeneralSettlementExcelError": "Pogreška izvoza/uvoza obračuna",
    "Error.SettlementReadWrite": "Pogreška čitanja/pisanja obračuna",
    "Error.SettlementImportNoSheet": "Nema lista 'Usluge' u datoteci",
    "Error.SettlementImportMissingId": "Nedostaje stupac 'Id' u datoteci",
    "Error.ProjectBranchInfrastructureServiceHasInvoicedSettlement": "Usluga infrastrukture podružnice projekta ima fakturirani obračun",
    "Error.ProjectBranchServiceHasSettledOrInvoicedSettlement": "Usluga podružnice projekta ima obračunati ili fakturirani obračun",
    "Error.OnDemand.NotScheduledServiceType": "Usluga na zahtjev može biti samo planiranog tipa",
    "Error.OnDemand.NotPerMonthSettlementType": "Usluga na zahtjev može biti samo po mjesečnom tipu obračuna",
    "Error.OnDemand.ProvidedCalendarSchedule": "Usluga na zahtjev ne može imati zadani raspored kalendara",
    "Error.OnDemand.ConstantCost": "Usluga na zahtjev ne može imati konstantni trošak",
    "Error.OnDemand.NonMunicipalWaste": "Usluga na zahtjev može biti samo tipa komunalnog otpada",
    "Error.HazardousWasteSettlementType": "Usluga opasnog otpada može biti samo po tipu obračuna na zahtjev",
    "Error.HazardousWasteEmptyLicensePlates": "Usluga opasnog otpada ne može imati prazne registracijske oznake",
    "Error.NoEmailToNotifyAboutCollectionRequest": "Pogreška! Narudžba se ne može registrirati zbog nedostatka e-maila za narudžbe. Odmah kontaktirajte svog Interzero POI nadzornika",
    "Error.CannotChangePriceForInvoicedServiceSettlements": "Nije moguće promijeniti cijenu za fakturirane obračune usluga za trenutni ili buduće mjesece",
    "Error.UserHasNoAssignedProject": "Nemate dodijeljen projekt, kontaktirajte Interzero",
    "Error.CollectionRequestAlreadyFinished": "Ovaj zahtjev za odvoz već je završen, prijavljen kao propušten ili otkazan, pa se više ne može mijenjati.",
    "Error.CollectionRequestSettlementLocked": "Ovaj zahtjev za odvoz pripada obračunu koji je već obračunat, fakturiran ili čeka prihvaćanje. Kod mjesečnog obračuna to vrijedi za sve zahtjeve tog mjeseca.",
    "Error.CollectionRequestCancellationWindowExpired": "Rok za otkazivanje ovog zahtjeva za odvoz je istekao. Molimo obratite se Interzerou.",
    "Error.CollectionRequestNotCancellableServiceType": "Zahtjevi za odvoz ove vrste usluge ne mogu se otkazati.",
    "Error.CollectionRequestNotCancelled": "Obrisati se može samo otkazani zahtjev za odvoz. Prvo ga otkažite.",
    "Error.CollectionRequestNotAccessible": "Ovaj zahtjev za odvoz ne pripada vašoj tvrtki."
  }
}
